/** Drawer width scale — from Figma side drawer spec (450px default). */
export const drawerSizes = ['sm', 'md', 'lg', 'xl', 'full-x-sidebar'] as const;

export type DrawerSize = (typeof drawerSizes)[number];

export const drawerDefaultSize: DrawerSize = 'md';

/** Content width per size. */
export const drawerContentWidth: Record<DrawerSize, string> = {
  sm: '360px',
  md: '450px',
  lg: '600px',
  xl: '900px',
  'full-x-sidebar': 'calc(100vw - 210px)',
};
